module.exports = __webpack_public_path__ + "static/media/heatingmap.30f542ad.jpeg";